import React, {Component} from 'react'
import {Modal, Select, Input, Button} from 'antd'
import {REASON_CANCEL} from './../../../helpers/reasonCancel'
import {singleCancelOrder} from "../../../../../services/api/3dApi"

const {TextArea} = Input

class CancelOrderItem extends Component {
    state = {
        isOpen: true,
        defaultSelect: '',
        reason: '',
        error: '',
        loading: false
    }

    _handleChange = (value) => {
        this.setState({
            defaultSelect: value,
            reason: value === 'other' ? '' : value,
            error: ''
        })
    }

    _handleCancel = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleChangeReason = (e) => {
        const {value} = e.target
        this.setState({
            reason: value.trim(),
            error: ''
        })
    }

    _handleSubmit = async () => {
        const {orderId, onChangeStatus, onFetchOrders, onResetAction} = this.props
        const {reason} = this.state

        if (!reason) return this.setState({
            error: 'Vui lòng chọn lý do huỷ đơn!'
        })

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                reason: reason
            }

            const {data: response} = await singleCancelOrder(orderId, payload)

            const {success, error} = response

            if (!success) return this.setState({
                error,
                loading: false
            })

            this.setState({
                isOpen: false,
                loading: false
            }, () => {
                onChangeStatus('cancelled')
                onFetchOrders()
                onResetAction()
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    render() {
        const {isOpen, defaultSelect, error, loading} = this.state
        const {orderTemplate} = this.props

        return (
            <Modal
                title="Hủy đơn"
                visible={isOpen}
                onCancel={this._handleCancel}
                onOk={this._handleSubmit}
                afterClose={this._handleAfterClose}
                footer={[
                    <Button key="back" onClick={this._handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" loading={loading} onClick={this._handleSubmit}>
                        OK
                    </Button>,
                ]}
            >
                <label className="mb-3">Bạn có chắc muốn hủy order <strong>#{orderTemplate}</strong>?</label>
                <Select placeholder="Select a reason" onChange={this._handleChange}>
                    {
                        REASON_CANCEL.map(option => {
                            const {name, value} = option
                            const valueStr = JSON.stringify(value)

                            return <Select.Option key={valueStr} value={value}>{name}</Select.Option>
                        })
                    }
                </Select>
                {defaultSelect === 'other' && (
                    <div className="mt-3">
                        <TextArea onChange={this._handleChangeReason} rows={4}/>
                    </div>
                )}
                {error && <div className="text-danger mt-3">{error}</div>}
            </Modal>
        )
    }
}

export default CancelOrderItem
